module.exports = __webpack_public_path__ + "img/7.e30a4e02.jpg";